var _style, _g, _g2, _g3, _g4, _g5;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgItemMasterData(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 235.69 235.69",
    style: {
      enableBackground: "new 0 0 235.69 235.69"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#7A7A7A;}\r\n\t.st1{fill:none;}\r\n\t.st2{fill:#FFFFFF;}\r\n\t.st3{fill:none;stroke:#FFFFFF;stroke-width:4.375;stroke-miterlimit:10;}\r\n\t.st4{fill:none;stroke:#FFFFFF;stroke-width:3.125;stroke-miterlimit:10;}\r\n\t.st5{fill:none;stroke:#FFFFFF;stroke-width:1.875;stroke-miterlimit:10;}\r\n\t.st6{fill:none;stroke:#FFFFFF;stroke-width:1.4452;stroke-miterlimit:10;}\r\n\t.st7{fill:none;stroke:#FFFFFF;stroke-width:3.1672;stroke-miterlimit:10;}\r\n\t.st8{fill:none;stroke:#FFFFFF;stroke-width:2.5;stroke-linecap:square;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st9{fill:none;stroke:#FFFFFF;stroke-width:4.2982;stroke-miterlimit:10;}\r\n\t.st10{fill:none;stroke:#FFFFFF;stroke-width:2.8804;stroke-miterlimit:10;}\r\n\t.st11{fill:none;stroke:#FFFFFF;stroke-width:4.0825;stroke-linecap:square;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st12{fill:none;stroke:#FFFFFF;stroke-width:5.1032;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st13{fill:none;stroke:#FFFFFF;stroke-width:4.0825;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st14{fill:none;stroke:#FFFFFF;stroke-width:5.1032;stroke-linecap:round;stroke-linejoin:round;}\r\n\t\r\n\t\t.st15{fill:none;stroke:#FFFFFF;stroke-width:5.1032;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:12.7183,12.7183;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "strzaka"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_3"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_4"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_5"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 37.47,
    y1: 153.85,
    x2: 86.4,
    y2: 153.85
  }), /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 37.47,
    y1: 164.05,
    x2: 86.4,
    y2: 164.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 37.47,
    y1: 174.26,
    x2: 86.4,
    y2: 174.26
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st12",
    points: "172.19,167.42 172.19,198.75 208.43,163.54 208.43,18.61 172.19,53.82 172.19,123.35  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "208.43,18.61 172.19,53.82 27.26,53.82 63.5,18.61  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st12",
    points: "172.19,167.42 172.19,198.75 131.49,198.75 27.26,198.75 27.26,53.82 172.19,53.82 172.19,123.35  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M100.8,18.61L71.16,53.82v73.48c5.27-5.95,10.54-11.9,15.81-17.85c5.3,5.95,10.61,11.9,15.91,17.85V53.82 c8.57-11.74,17.14-23.47,25.7-35.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M180.84,131.78c-5.62,7.32-11.24,14.64-16.86,21.95l-35.62,1.86l74.36-54.7l-21.92,81.37 c-5.57-9.61-11.14-19.22-16.7-28.83"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M160.97,164.05c-0.48,0.99-1.42,2.89-2.88,5.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M150.97,179.97c-8.47,10.88-22.59,24.28-44.09,31.03c-27.29,8.56-51.09,1.6-64.5-4.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M36.65,203.86c-2.65-1.4-4.46-2.53-5.3-3.06"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItemMasterData);
export default __webpack_public_path__ + "static/media/Item_Master_Data.895819d0b1a3d539a317b7037b288ebd.svg";
export { ForwardRef as ReactComponent };